export default `
mutation restoreClient($id: ID!, $serviceProviderId: ID!) {
  restoreClient(id: $id, serviceProviderId: $serviceProviderId) {
    id
    serviceProviderId
    updatedAt
    propertyIds
    firstName
    lastName
    email
    isArchived
    isDeleted
  }
}
`;
